
import {Vue, Component, Emit, Prop} from 'vue-property-decorator';

import {RouteName, SiteId} from "@/enums";

	@Component({})

	export default class AppButton extends Vue {
		@Prop() previousPage!: RouteName;

		@Emit()
		private click(): void {}
	}
